import { Component, EventEmitter, Input, Output } from '@angular/core';

/** Two-state switch with a label either side, e.g. `Units ( ) $`. */
@Component({
    selector: 'emd-toggle',
    template: `
    <div
      class="emd-toggle"
      role="switch"
      tabindex="0"
      [attr.aria-checked]="value === rightValue"
      [attr.aria-label]="leftLabel + ' or ' + rightLabel"
      (click)="toggle()"
      (keydown.enter)="toggle()"
      (keydown.space)="toggle()"
    >
      <span class="emd-toggle-label" [class.active]="value === leftValue">{{ leftLabel }}</span>
      <span class="emd-toggle-track" [class.on]="value === rightValue">
        <span class="emd-toggle-knob"></span>
      </span>
      <span class="emd-toggle-label" [class.active]="value === rightValue">{{ rightLabel }}</span>
    </div>
  `,
    styleUrls: ['./emd-toggle.component.scss'],
    standalone: false
})
export class EmdToggleComponent {
  @Input() leftLabel = 'Units';
  @Input() rightLabel = '$';
  @Input() leftValue = 'units';
  @Input() rightValue = '$';
  @Input() value = 'units';
  @Output() valueChange = new EventEmitter<string>();

  toggle(): void {
    this.value = this.value === this.leftValue ? this.rightValue : this.leftValue;
    this.valueChange.emit(this.value);
  }
}
